<template>  
  <div class='photo-card-comment'>
    <div class='attendee-message'>
      <span class='attendee'>
        {{comment.attendee_name}}
      </span>
      {{comment.comment}}
    </div>
    <div class='comment-from-now themePrimaryColor'>
      {{ this.createdFromNow() }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {

  props: ['comment'],

  computed: {

    attendeeName () {
      return this.photo.attendee_name
    },

    momentCreatedAt () {
      return new moment.utc(this.comment.created_at)
    }

  },

  methods: {
    createdFromNow () {
      return this.momentCreatedAt.fromNow()
    },
  },

};
</script>

<style scoped>
  .photo-card-comment {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .attendee {
    font-weight: bold;
  }

  .comment-from-now {
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 0.6rem;
  }


</style>